export interface PillTabMenuProps {
  children: React.ReactNode;
  ariaLabel?: string;
  className?: string;
}

export default function PillTabMenu({
  children,
  ariaLabel,
  className,
}: PillTabMenuProps) {
  return (
    <nav
      className={`mt-4 flex flex-wrap gap-2 sm:gap-4 ${className ?? ""}`}
      aria-label={ariaLabel ?? "Tabs"}
    >
      {children}
    </nav>
  );
}
